<template>
	<div class="user-container">
		<div style="display: flex; justify-content: space-between;margin-bottom: 20px;">
			<el-button type="success" @click="openDialog('1')">新增</el-button>
			<el-select v-model="currentClassify" placeholder="请选择" @change="changeClassify">
				<el-option v-for="item in classifysOption" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</div>
		<el-table :data="tableData" style="width: 100%" stripe border>
			<el-table-column prop="id" label="id" width="100">
			</el-table-column>
			<el-table-column prop="class_name" label="分类名" width="120">
			</el-table-column>
			<el-table-column prop="title" label="标题">
			</el-table-column>
			<el-table-column prop="description" label="description">
				<template slot-scope="scope">
					<el-tooltip placement="top">
						<div class="shwo-des" slot="content">{{scope.row.description}}</div>
						<div class="des-content">{{scope.row.description}}</div>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column prop="keywords" label="keywords">
				<template slot-scope="scope">
					<div class="des-content">{{scope.row.keywords}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="update_time" label="时间" width="180">
			</el-table-column>
			<el-table-column prop="page_view" label="浏览量" width="120">
			</el-table-column>
			<el-table-column width="175">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="openDialog('2',scope.row)">修改</el-button>
					<delPop @confirm="delUser(scope.row.id)"></delPop>
				</template>
			</el-table-column>
		</el-table>
		<div style="display: flex;justify-content: center;">
			<el-pagination background layout="prev, pager, next" :total="total" style="margin-top: 40px;"
				@current-change="changePage">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import mixins from '../../mixins.js'
	import {
		classifys,
	} from '../../api/classify.js'
	import {
		contents,
		contentByClassify,
		delContent
	} from '../../api/content.js'
	export default {
		mixins: [mixins],
		data() {
			return {
				tableData: [],
				rules: {
					name: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
				},
				classifysOption: [],
				currentClassify: -1
			}
		},
		methods: {
			async getData(e) {
				if (e && e != -1) {
					let params = {
						...this.queryParams,
						class_id: e
					}
					let res = (await contentByClassify(params)).data
					this.tableData = res.data
					this.total = res.count
				} else {
					let res = (await contents(this.queryParams)).data
					this.tableData = res.data
					this.tableData.sort((a,b) => {
						return b.id - a.id
					})
					this.total = res.count
				}
			},
			openDialog(i, row) {
				if (i == 1) {
					this.$router.push({
						path: '/editConent'
					})
				} else {
					this.$router.push({
						path: "/editConent",
						query: {
							id: row.id
						}
					})
				}
			},
			async delUser(id) {
				await delContent(id)
				this.$message.success('删除成功')
				this.getData()
			},
			changeClassify(e) {
				console.log(e)
				this.getData(e)
			}
		},
		async created() {
			this.classifysOption = (await classifys({
				pageNo: 1,
				pageSize: 100
			})).data.data.map(e => {
				return {
					label: e.name,
					value: e.id
				}
			})
			this.classifysOption.unshift({
				label: '全部',
				value: -1
			})
		}
	}
</script>

<style>
	.des-content {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.shwo-des {
		width: 200px !important;
		word-break: break-all !important;
	}
</style>
